import * as React from "react";
import * as styles from "./styles.scss";

export class Preloader extends React.Component {
  render() {
    return <div className={`svgpreloader ${styles.preloader}`} />;
  }
}
